

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"96","height":"76","viewBox":"0 0 96 76","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n  ", h('path', {"d":"M3 27.8605C11.2255 33.7567 19.4472 39.6547 27.6651 45.5548C28.3854 54.8415 29.1018 64.1302 29.8144 73.4208C32.6494 66.7392 35.4845 60.0519 38.3196 53.3589L66.9844 73.007L93 3L3 27.8605Z","stroke":"#A7CEF4","stroke-width":"4.05402","stroke-linecap":"round","stroke-linejoin":"round"}, []), "\n  ", h('path', {"d":"M29.8431 73.422L51.7785 62.5664","stroke":"#A7CEF4","stroke-width":"4.05402","stroke-linecap":"round","stroke-linejoin":"round"}, []), "\n  ", h('path', {"d":"M38.6299 52.5499L91.184 4.66211L28.1191 45.2055","stroke":"#A7CEF4","stroke-width":"4.05402","stroke-miterlimit":"10","stroke-linecap":"round"}, []), "\n"]);
};

        